import { Link } from 'react-router-dom'
import forvetLogo from '../../../assets/logo-forvet-dark.svg'
import forvetLogoElite from '../../../assets/fv_logo-golden.png'
import useEliteStatus from '../../../hooks/useEliteStatus'
import { IconCircle, IconCircle0Filled, IconCircleFilled } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { Skeleton } from '@mantine/core'
import axios from 'axios'

export default function HeaderLogo() {
   const isElite = useEliteStatus()

   const logo = isElite ? forvetLogoElite : forvetLogo

   return (
      <Link className='logo-container' to='/'>
         <img src={logo} alt="forvet" />
         <LogoStudentActives />
      </Link>
   )
}


const LogoStudentActives = () => {

   const [state, setState] = useState({ isLoading: false, data: null, error: false })

   useEffect(() => {
      const getStudentCount = async () => {
         try {
            setState(prev => ({ ...prev, isLoading: true }))
            // Simulación de delay de red
            const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/getHomeLandingStats?is_student=true`
            const { data } = await axios.get(URL)
            setState(prev => ({ ...prev, data }))
         } catch (error) {
            console.log(error)
            setState(prev => ({ ...prev, error: true }))

         } finally {
            setState(prev => ({ ...prev, isLoading: false }))
         }
      }
      getStudentCount()
   }, [])

   if (state.isLoading) return <Skeleton h='12px' animated w='150px' />

   if (state.error || !state.data?.counter) return <></>

   return <div className='logo--student-badge'>
      <IconCircle size={12} fill='#5bf247' color='#5bf247' />
      <span>Somos {state.data?.counter[0]?.count} veterinarios</span>
   </div>
}
